<template>
    <div>
        <rkm-list
            :items="data.model.solicitacoesExamesComuns"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col>
                        <strong>CID 10</strong><br />{{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
                    </rkm-col>

                    <rkm-col>
                        <strong>CIAP 2</strong><br />{{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Classificação de risco</strong><br />{{item.classificacaoRiscoDescricaoEncaminhamento}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Justificativa do procedimento</strong><br />{{item.justificativa}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Observações</strong><br />{{item.observacao}}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:trailling="{index, item}">

                <rkm-button
                    :disabled="item.exames.filter(i => !!i.checked).length === 0"
                    @click.stop="print(item)"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click.stop="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-row class="p-2">
                    <rkm-col>
                        <template v-if="item.exames.length > 0">
                            <rkm-button
                                v-if="item.exames.length === item.exames.filter(m => !!m.checked).length"
                                @click="item.exames.map(m => $set(m, 'checked', false))"
                                class="mb-2"
                                color="primary"
                            >
                                Desmarcar todos
                            </rkm-button>

                            <rkm-button
                                v-else
                                @click="item.exames.map(m => $set(m, 'checked', true))"
                                class="mb-2"
                                color="primary"
                            >
                                Selecionar todos
                            </rkm-button>
                        </template>

                        <rkm-table
                            :fields="fields"
                            :items="item.exames"
                            hide-filters
                            hide-pagination
                        >
                            <template v-slot:cell(check)="{ item }">
                                <rkm-form-checkbox v-model="item.checked" />
                            </template>

                            <template v-slot:cell(exame)="{ item }">
                                {{ item.codigo ? `${formatProcedimento(item.codigo)} - ${item.nome}` : item.nome }}
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-list>

        <rkm-area
            background-color="primary"
            closed
            title="Histórico de solicitações de exames laboratoriais"
            type="box"
        >
            <rkm-list
                :items="data.form.solicitacoesExamesComuns"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <template v-if="item.origem === 'ambulatorio'">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Origem</strong><br />Ambulatório
                            </rkm-col>

                            <rkm-col>
                                <strong>Data / Hora</strong><br />{{item.dataHora}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                            </rkm-col>
                        </rkm-row>

                        <hr />

                        <rkm-row>
                            <rkm-col>
                                <strong>CID 10</strong><br />{{item.cidDescricao ?? '-'}}
                            </rkm-col>

                            <rkm-col>
                                <strong>CIAP 2</strong><br />{{item.ciapDescricao ?? '-'}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Classificação do exame</strong><br />{{item.classificacaoNome}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Justificativa do procedimento</strong><br />{{item.justificativa}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Observações</strong><br />{{item.observacao}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-else-if="item.origem === 'exame-laboratorial'">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Origem</strong><br />Exame laboratorial
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Data / Hora agendada</strong><br />{{item.dataHoraAgendada}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Profissional da coleta</strong><br />{{item.coletaUsuarioNome}} - {{item.coletaOcupacaoNome}}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </template>

                <template v-slot:collapse="{item}">
                    <div class="p-2">
                        <template v-if="item.origem === 'ambulatorio'">
                            <rkm-row>
                                <rkm-col>
                                    <rkm-table
                                        :fields="fields"
                                        :items="item.exames"
                                        hide-filters
                                        hide-pagination
                                    >
                                        <template v-slot:cell(exame)="{item}">
                                            {{item.descricao}}
                                        </template>
                                    </rkm-table>
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <template v-else-if="item.origem === 'exame-laboratorial'">
                            <rkm-area title="Exame(s)">
                                <rkm-table
                                    :fields="exameLaboratorialExameFields"
                                    :items="item.exames"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(actions)="{ item }">
                                        <rkm-button
                                            v-if="item.dataResultado"
                                            @click="imprimirResultadoExameLaboratorial(item)"
                                            color="primary"
                                            small
                                            title="Imprimir resultado"
                                        >
                                            <rkm-icon icon="print" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>
                            </rkm-area>

                            <rkm-area
                                v-if="item.laudos.length > 0"
                                title="Laudo(s)"
                            >
                                <rkm-table
                                    :fields="exameLaboratorialLaudoFields"
                                    :items="item.laudos"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(actions)="{ item }">
                                        <rkm-button
                                            @click="imprimirLaudoExameLaboratorial(item)"
                                            color="primary"
                                            small
                                            title="Imprimir laudo"
                                        >
                                            <rkm-icon icon="print" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>
                            </rkm-area>
                        </template>
                    </div>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            @procedimentos-incluidos="handlePrintProcedimentosIncluded($event)"
            ref="Modal"
        />
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, formats, stringCase, object} from '@/mixins'

// Components.
import Modal from './Modal'

// Vuex.
import {mapActions} from 'vuex'

// Enums.
import procedimento from '@/enums/sigtap/procedimento'

export default {
    components: {Modal},
    computed: {
        examesCitopatologicosColoUtero() {

            return [
                this.enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_CITOPATOLOGICO_DE_COLO_DE_UTERO,
                this.enums.procedimento.EXAME_CITOPATOLOGICO_CERVICO_VAGINAL_MICROFLORA,
                this.enums.procedimento.EXAME_CITOPATOLOGICO_CERVICO_VAGINAL_MICROFLORA_RASTREAMENTO,
            ]
        },
        examesCitopatologicosMama() {

            return [
                this.enums.procedimento.EXAME_CITOPATOLOGICO_DE_MAMA,
            ]
        }
    },
    data() {
        return {
            selectedAll: false,
            indeterminate: false,
            fields: [
                {key: 'check', label: '#', class: 'col-min text-center'},
                {key: 'exame', label: 'Exame', sortable: true},
            ],
            exameLaboratorialExameFields: [
                {key: 'exameGrupoNome', label: 'Exame', sortable: true},
                {key: 'dataColeta', label: 'Data da coleta', formatter: v => v ? this.formatDate(v) : null, sortable: true},
                {key: 'dataResultado', label: 'Data do resultado', formatter: v => v ? this.formatDate(v) : null, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
            exameLaboratorialLaudoFields: [
                {key: 'arquivo', label: 'Laudo', sortable: true},
                {key: 'data', label: 'Data', formatter: v => this.formatDate(v), sortable: true},
                {key: 'responsavel', label: 'Responsável', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
            enums: { procedimento }
        }
    },
    created() {
        this.repositories = {
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
            impressaoExameLaboratorial: this.getConectaSusRepository('impressao.exameLaboratorial'),
            laudoExameLaboratorial: this.getConectaSusRepository('exameLaboratorial.importarLaudo'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a solicitação de exame comum?', async () => {
                this.data.model.solicitacoesExamesComuns.splice(index, 1)
            })
        },
        print(item) {

            item = this.clone(item)

            item.emAtendimento = true
            item.atendimentoId = this.data.additionals.atendimentoId

            item.exames = item.exames.filter(e => (e.checked ?? false))

            if (item.exames.find(e => this.examesCitopatologicosColoUtero.includes(e.codigo))) {

                this.setLoading()

                this.repositories.pdf.requisicaoExameCitopatologicoColoUtero(null, {
                    em_atendimento: true,
                    paciente_id: this.data.additionals.paciente.id,
                })
                    .then(({data, headers}) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            if (this.data.additionals.paciente.hasCamposObrigatoriosMama
                && item.exames.find(e => this.examesCitopatologicosMama.includes(e.codigo))) {

                this.setLoading()

                this.repositories.pdf.requisicaoExameCitopatologicoMama(null, {
                    em_atendimento: true,
                    paciente_id: this.data.additionals.paciente.id,
                })
                    .then(({data, headers}) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            item.exames = item.exames.filter(e => !this.examesCitopatologicosColoUtero.includes(e.codigo))

            if (this.data.additionals.paciente.hasCamposObrigatoriosMama) {
                item.exames = item.exames.filter(e => !this.examesCitopatologicosMama.includes(e.codigo))
            }

            if (item.exames.length === 0) return

            this.setLoading()

            this.repositories.pdf.servicoAnaliseDiagnosticoTerapiaSolicitacaoExame(this.data.additionals.paciente.id, this.camelObjectKeysToSnakeRecursive(item))
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        imprimirResultadoExameLaboratorial(item) {
            this.setLoading()

            this.repositories.impressaoExameLaboratorial.exame({
                agendamento_id: item.agendamentoId,
                pertence_grupo: item.pertenceGrupo,
                exame_grupo_id: item.exameGrupoId,
                mapa_agrupado: item.mapaAgrupado,
                assinatura_profissional_id: item.assinaturaProfissionalId,
            })
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        imprimirLaudoExameLaboratorial(item) {
            if (item.url) {
                window.open(item.url, '_blank')

                return
            }

            this.setLoading()

            this.repositories.laudoExameLaboratorial.download(item.id)
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePrintProcedimentosIncluded(codigos) {

            if (codigos.find(codigo => this.examesCitopatologicosColoUtero.includes(codigo))) {

                this.setLoading()

                this.repositories.pdf.requisicaoExameCitopatologicoColoUtero(null, {
                    em_atendimento: true,
                    paciente_id: this.data.additionals.paciente.id,
                })
                    .then(({data, headers}) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

            if (this.data.additionals.paciente.hasCamposObrigatoriosMama
                && codigos.find(codigo => this.examesCitopatologicosMama.includes(codigo))) {

                this.setLoading()

                this.repositories.pdf.requisicaoExameCitopatologicoMama(null, {
                    em_atendimento: true,
                    paciente_id: this.data.additionals.paciente.id,
                })
                    .then(({data, headers}) => this.openFile(data, headers['content-type']))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
    },
    mixins: [error, file, repository, formats, stringCase, object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>